import { Card } from "@mui/material";

export const ResultCard: React.FC<{
	onClick: () => void;
	children: React.ReactNode;
}> = ({ onClick, children }) => {
	return (
		<Card
			sx={{
				marginBottom: "10px",
				cursor: "pointer",
			}}
			onClick={onClick}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					gap: "10px",
					padding: "10px",
				}}
			>
				{children}
			</div>
		</Card>
	);
};
